module.exports = __webpack_public_path__ + "img/login.99dfd962.jpg";